import React from 'react';
import ErrorIcon from '../assets/images/ErrorIcon.svg';

export default () => {
    return <img src={ErrorIcon} alt="" />;
  };
  